module.exports = __webpack_public_path__ + "static/media/sau.7bcc40fa.png";